import { Directive, forwardRef } from '@angular/core';
import { FormControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
import { formatCpf, validCpf } from '../../utils';

const CPF_LENGTH: number = 11;

@Directive({
  selector: '[appCpf]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => CpfDirective),
      multi: true,
    },
  ],
  standalone: false,
})
export class CpfDirective implements Validator {
  validate(control: FormControl): ValidationErrors | null {
    return CpfDirective.isValid(control.value);
  }

  static isValid = (value: string): ValidationErrors | null => {
    const sanitize: string = formatCpf(value);
    if (sanitize.length !== CPF_LENGTH) {
      return { error: true };
    }
    return value && validCpf(value) ? null : { error: true };
  };
}
